import { MaintenanceLayout } from './MaintenanceLayout';

interface MaintenanceStateProps {
  customMessage: string;
  onTryAgain: () => void;
}

const DEFAULT_BODY = "Some maintenance behind the scenes. We'll be back shortly.";

/**
 * Maintenance state: server is the problem. The recovery poller in
 * @lib/maintenance/poller re-runs the full discriminator probe every 30s
 * via maybeProbe('poller') (favicon + /api/maintenance + /health) while
 * we're in this state and flips back to 'ready' when all three signals
 * confirm recovery; the pulsing mascot signals that background activity.
 * The user can also tap Try Again (rendered by MaintenanceLayout) to
 * re-probe immediately.
 */
export function MaintenanceState({ customMessage, onTryAgain }: MaintenanceStateProps) {
  const trimmed = customMessage.trim();
  const body = trimmed.length > 0 ? trimmed : DEFAULT_BODY;

  return (
    <MaintenanceLayout onTryAgain={onTryAgain}>
      <div className="relative w-24 h-24 mx-auto mb-2">
        <img src="/signup-mascot.svg" alt="" className="w-full h-full" aria-hidden="true" />
        <span
          aria-hidden="true"
          className="absolute -inset-2 rounded-full border-2 border-mb-teal/50 animate-maintenance-pulse"
        />
      </div>
      {/* h2 (not h1): the takeover renders as a sibling of RouterProvider, so
          the underlying route's h1 stays mounted in the DOM. Two h1s in the
          same document outline confuse screen readers and a11y audits.
          Visual styling unchanged - text-xl font-semibold matches what an
          h1 would render. */}
      <h2 className="text-xl font-semibold text-gray-900">Just a moment.</h2>
      <p className="text-sm text-gray-600">{body}</p>
    </MaintenanceLayout>
  );
}
